import { Avatar } from "@mui/material";
import React, { useState } from "react";
import "./ChatScreen.css";

function ChatScreen() {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      name: "Ellen",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/b/b8/Ellen_DeGeneres_2011.jpg",
      message: "Whats up",
    },
    {
      name: "Ellen",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/b/b8/Ellen_DeGeneres_2011.jpg",
      message: "Hows it going?",
    },
    {
      message: "Hi !!!",
    },
  ]);

  const handleSend = (e) => {
    e.preventDefault();

    setMessages([...messages, { message: input }]);
    setInput("");
  };

  return (
    <div className="chatScreen">
      <p className="chatScreen__timestamp">
        YOU MATCHED WITH ELLEN ON 10/08/2021
      </p>
      {messages.map(({ message, name, image }) =>
        name ? (
          <div className="chatScreen__message">
            <Avatar className="chatScreen__image" alt={name} src={image} />
            <p className="chatScreen__text">{message}</p>
          </div>
        ) : (
          <div className="chatScreen__message">
            <p className="chatScreen__textUser">{message}</p>
          </div>
        )
      )}

      <form className="chatScreen__input">
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="chatScreen__inputField"
          type="text"
          placeholder="Type a message..."
        />
        <button
          onClick={handleSend}
          type="submit"
          className="chatScreen__inputBtn"
        >
          SEND
        </button>
      </form>
    </div>
  );
}

export default ChatScreen;
